import MultiSelectSearchDropdown from '../MultiSelectSearchDropdown/MultiSelectSearchDropdown';
import { PEC_PICKER_LABELS } from '../../DealDrawerConstants';
import { PecPickerOption } from '../../pecFieldSelection';
import { plusPurpleCircle } from '../../../../assets/hostedassets';
import Button from '../../../_custom/Button/Button';
import drawerStyles from '../../ManageDealDrawer.module.scss';
import styles from './FieldPicker.module.scss';
import { clsx } from 'clsx';

interface FieldPickerProps {
    options: PecPickerOption[];
    selected: string[];
    onSelectionChange: (selected: string[]) => void;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    disabled?: boolean;
}

export const FieldPicker: React.FC<FieldPickerProps> = ({ options, selected, onSelectionChange, open, onOpenChange, disabled = false }) => (
    <div className={styles.PickerRow}>
        <span className={styles.PickerLabel}>{PEC_PICKER_LABELS.pickerLabel}</span>
        <div className={styles.PickerControl}>
            <MultiSelectSearchDropdown
                options={options}
                selectedItems={selected}
                toggleSelection={(next) => onSelectionChange(next.filter((value): value is string => value !== null))}
                maxVisibleChips="auto"
                sortSelectedOnTop
                open={open}
                onOpenChange={onOpenChange}
                placeholder={PEC_PICKER_LABELS.pickerPlaceholder}
                showFloatingLabel={false}
                showSelectAll={true}
                selectedItemClassName={clsx(drawerStyles.FieldChip, styles.FieldChip)}
                selectedItemStyle={{ maxWidth: 'none' }}
                disabled={disabled}
                searchBarStyle={{
                    padding: '0 0.75rem',
                }}
            />
        </div>
        <span className={styles.AddButtonWrapper} onMouseDown={(event) => event.stopPropagation()}>
            <Button
                type="button"
                text={PEC_PICKER_LABELS.add}
                icon={plusPurpleCircle}
                iconSize="14"
                onClick={() => onOpenChange(!open)}
                disabled={disabled}
                className={styles.AddButton}
            />
        </span>
    </div>
);

export default FieldPicker;
